import { useMemo } from 'react';

import { TokenFormatter, NameAndCreateDateWithUserFormatter } from '@Components/Grid/components/Table/formatters';
import column, { defaultActionsColumn, deleteAction, editAction, defaultActiveColumn } from '@Components/Grid/utils/column';

export default function useColumns() {
  return useMemo(() => [
    column.accessor('id', {
      header: 'Token',
      cell: info => <TokenFormatter info={info} />,
      enableSorting: false,
      maxSize: 100,
    }),
    column.accessor('description', {
      header: 'Description',
      cell: info => <NameAndCreateDateWithUserFormatter info={info} />,
    }),
    defaultActiveColumn(),
    defaultActionsColumn(editAction, deleteAction),
  ], [])
}
